import { IconButton, Tooltip } from "@mui/material";
import { BookmarkRemove } from "@mui/icons-material";
import { useRemoveFromSavedSearchMutation, UserRecentSearchOutput } from "api";
import { FC, useCallback } from "react";
import { updateCacheAfterSavedSearchRemoval } from "graphql/cache";

type RemoveSavedSearchButtonProps = Pick<
  UserRecentSearchOutput,
  "isSaved" | "searchId"
>;

export const RemoveSavedSearchButton: FC<RemoveSavedSearchButtonProps> = ({
  searchId,
  isSaved,
}) => {
  const [removeFromSavedSearch] = useRemoveFromSavedSearchMutation();

  const handleRemoveFromSavedSearch = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      e.stopPropagation();
      removeFromSavedSearch({
        variables: {
          searchId,
        },
        update: updateCacheAfterSavedSearchRemoval(searchId as string),
      });
    },
    [searchId, removeFromSavedSearch]
  );

  if (isSaved)
    return (
      <Tooltip title="Remove from saved searches">
        <IconButton
          sx={{ width: "40px", height: "40px", marginLeft: "auto" }}
          onClick={handleRemoveFromSavedSearch}
        >
          <BookmarkRemove fontSize="small" color="error" />
        </IconButton>
      </Tooltip>
    );
  return null;
};
